import { render, staticRenderFns } from "./InlineGoalMenubar.vue?vue&type=template&id=a8c52b3a&"
import script from "./InlineGoalMenubar.vue?vue&type=script&lang=js&"
export * from "./InlineGoalMenubar.vue?vue&type=script&lang=js&"
import style0 from "./InlineGoalMenubar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports